<template>
    <div class="row mb-3">
        <div class="col">
            <div class="form-floating">
                <select class="form-select" name="day" v-model="day" disabled>
                    <option :value="day">
                        {{ day }}
                    </option>
                </select>
                <label for="inputDay">Day</label>
            </div>
        </div>
        <div class="col">
            <div class="form-floating">
                <select class="form-select" name="month" v-model="month" disabled>
                    <option v-for="month in months" :value="month.value">
                        {{ month.text }}
                    </option>
                </select>
                <label for="inputMonth">Month</label>
            </div>
        </div>
        <div class="col">
            <div class="form-floating">
                <select class="form-select" name="year" v-model="year" disabled>
                    <option :value="year">
                        {{ year }}
                    </option>
                </select>
                <label for="inputYear">Year</label>
            </div>
        </div>
    </div>

    <div class="form-floating mb-3">
        <input type="number" class="form-control" id="inputRainfall" name="rainfall" step=".01" v-model="rainfall">
        <label for="inputRainfall">Rainfall ({{rainfallUnit.symbol}})</label>
    </div>

    <div class="row">
        <div class="col-6">
            <div class="form-floating mb-3">
                <input type="number" class="form-control" id="inputTempLow" name="temp_low" step=".1" min="-999.9" max="999.9" v-model="templow">
                <label for="inputTempLow">Low Temp ({{tempUnit.symbol}})</label>
            </div>
        </div>
        <div class="col-6">
            <div class="form-floating mb-3">
                <input type="number" class="form-control" id="inputTempHigh" name="temp_high" step=".1" min="-999.9" max="999.9" v-model="temphigh">
                <label for="inputTempHigh">High Temp ({{tempUnit.symbol}})</label>
            </div>
        </div>
    </div>

    <div class="container p-0">
        <div class="row g-2 mb-3 text-center">
            <div class="col-4 col-lg-2" role="button" @click="setFog">
                <div class="p-2 p-md-3 border bg-light" :class="{'border-primary': eventFog}">
                    <i class="bi-cloud-fog fs-2" :class="{'text-primary': eventFog}"></i>
                    <p class="mb-0" :class="{'text-primary': eventFog}">Fog</p>
                </div>
            </div>
            <div class="col-4 col-lg-2" role="button" @click="setHail">
                <div class="p-2 p-md-3 border bg-light" :class="{'border-primary': eventHail}">
                    <i class="bi-cloud-hail fs-2" :class="{'text-primary': eventHail}"></i>
                    <p class="mb-0" :class="{'text-primary': eventHail}">Hail</p>
                </div>
            </div>
            <div class="col-4 col-lg-2" role="button" @click="setSnow">
                <div class="p-2 p-md-3 border bg-light" :class="{'border-primary': eventSnow}">
                    <i class="bi-cloud-snow fs-2" :class="{'text-primary': eventSnow}"></i>
                    <p class="mb-0" :class="{'text-primary': eventSnow}">Snow</p>
                </div>
            </div>
            <div class="col-4 col-lg-2" role="button" @click="setThunder">
                <div class="p-2 p-md-3 border bg-light" :class="{'border-primary': eventThunder}">
                    <i class="bi-cloud-lightning fs-2" :class="{'text-primary': eventThunder}"></i>
                    <p class="mb-0" :class="{'text-primary': eventThunder}">Thunder</p>
                </div>
            </div>
            <div class="col-4 col-lg-2" role="button" @click="setSun">
                <div class="p-2 p-md-3 border bg-light" :class="{'border-primary': eventSun}">
                    <i class="bi-sun fs-2" :class="{'text-primary': eventSun}"></i>
                    <p class="mb-0" :class="{'text-primary': eventSun}">Sun</p>
                </div>
            </div>
            <div class="col-4 col-lg-2" role="button" @click="setCloud">
                <div class="p-2 p-md-3 border bg-light" :class="{'border-primary': eventCloud}">
                    <i class="bi-cloud fs-2" :class="{'text-primary': eventCloud}"></i>
                    <p class="mb-0" :class="{'text-primary': eventCloud}">Cloud</p>
                </div>
            </div>
        </div>
    </div>

    <div class="d-grid mb-3">
        <input type="hidden" name="fog" v-model="eventFog" />
        <input type="hidden" name="hail" v-model="eventHail" />
        <input type="hidden" name="snow" v-model="eventSnow" />
        <input type="hidden" name="thunder" v-model="eventThunder" />
        <input type="hidden" name="sun" v-model="eventSun" />
        <input type="hidden" name="cloud" v-model="eventCloud" />
        <button type="submit" class="btn btn-lg btn-primary">Save</button>
    </div>
</template>

<script>
export default {
    props: [
        'id',
        'day',
        'month',
        'year',
        'rainfall',
        'fog',
        'snow',
        'hail',
        'thunder',
        'sun',
        'cloud',
        'templow',
        'temphigh',
        'rainfallUnit',
        'tempUnit'
    ],
    data() {
        return {
            months: [
                { value: '1', text: 'January' },
                { value: '2', text: 'February' },
                { value: '3', text: 'March' },
                { value: '4', text: 'April' },
                { value: '5', text: 'May' },
                { value: '6', text: 'June' },
                { value: '7', text: 'July' },
                { value: '8', text: 'August' },
                { value: '9', text: 'September' },
                { value: '10', text: 'October' },
                { value: '11', text: 'November' },
                { value: '12', text: 'Decemeber' },
            ],
            eventFog: this.fog,
            eventSnow: this.snow,
            eventHail: this.hail,
            eventThunder: this.thunder,
            eventSun: this.sun,
            eventCloud: this.cloud,
        };
    },
    methods: {
        setFog() {
            this.eventFog = 1 - this.eventFog;
        },
        setHail() {
            this.eventHail = 1 - this.eventHail;
        },
        setSnow() {
            this.eventSnow = 1 - this.eventSnow;
        },
        setThunder() {
            this.eventThunder = 1 - this.eventThunder;
        },
        setSun() {
            this.eventSun = 1 - this.eventSun;
        },
        setCloud() {
            this.eventCloud = 1 - this.eventCloud;
        }
    }
};
</script>
